import { axios } from '../services/axios';

const getPlans = async ({ companyId, partnerId, wholesalerId }) => {
    let url = '';
    if (companyId) {
        url = `/company/${companyId}/plans/available`;
    } else if (partnerId) {
        url = `/partner/${partnerId}/plans/available`;
    } else if (wholesalerId) {
        url = `/wholesaler/${wholesalerId}/plans/available`;
    } else {
        throw new Error('No valid ID provided');
    }
    const res = await axios.get(url);
    return res.data;
};

export default getPlans;
